globalThis.jotaiAtomCache = globalThis.jotaiAtomCache || {
  cache: new Map(),
  get: function get(name, inst) {
    if (this.cache.has(name)) {
      return this.cache.get(name);
    }

    this.cache.set(name, inst);
    return inst;
  }
};
import _styled from "styled-components";
import { memo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var FormLabelWrapper = /*#__PURE__*/memo(function (_ref) {
  var label = _ref.label,
      id = _ref.id,
      disabled = _ref.disabled,
      children = _ref.children,
      isFullWidth = _ref.isFullWidth;
  return /*#__PURE__*/_jsxs(Wrapper, {
    $isFullWidth: isFullWidth,
    children: [label ? /*#__PURE__*/_jsx(LabelWrapper, {
      children: /*#__PURE__*/_jsx(StyledLabel, {
        htmlFor: id,
        disabled: disabled,
        children: label
      })
    }) : null, children]
  });
});
export default FormLabelWrapper;

var Wrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "forminput-with-label__Wrapper",
  componentId: "sc-63qbkf-0"
})(["", ""], function (_ref2) {
  var $isFullWidth = _ref2.$isFullWidth;
  return $isFullWidth ? {
    "width": "100%"
  } : {};
});

var LabelWrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "forminput-with-label__LabelWrapper",
  componentId: "sc-63qbkf-1"
})(["", ""], {
  "marginBottom": "0.5rem",
  "display": "block"
});

var StyledLabel = /*#__PURE__*/_styled.label.withConfig({
  displayName: "forminput-with-label__StyledLabel",
  componentId: "sc-63qbkf-2"
})(["", ""], function (_ref3) {
  var disabled = _ref3.disabled;
  return disabled ? {
    "--tw-text-opacity": "1",
    "color": "rgb(156 163 175 / var(--tw-text-opacity))"
  } : {};
});